import PropTypes from 'prop-types';

const propType = {
  id: PropTypes.string,
  url: PropTypes.string.isRequired,
  thumb: PropTypes.string,
  originalName: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.number,
};

export default { propType };
